// tags.js
import axios from 'axios'
export default {
  data () {
    return {
      tags: [],
      products: [],
      loading: false,
      searchQuery: ''
    }
  },
  computed: {
    currentTagName () {
      if (this.$route.query.tag_id && this.tags.length > 0) {
        const foundTag = this.tags.find(t => t.id === this.$route.query.tag_id)
        return foundTag ? foundTag.name : ''
      }
      return ''
    }
  },
  methods: {
    async fetchTags (query = '') {
      this.$store.dispatch('isLoading', true)
      try {
        const params = {
          pageSize: 50,
          query: query
        }
        const response = await axios.get('/tags', { params })
        this.tags = response.data.data
      } catch (error) {
        console.error('取得標籤失敗:', error)
      } finally {
        this.$store.dispatch('isLoading', false)
      }
    },

    // 2. 搜尋特定名稱的標籤
    searchTags () {
      this.fetchTags(this.searchQuery)
    },

    // 3. 使用 Tag Slug 篩選商品 (例如：hot, new)
    async getProductsBySlug (slug) {
      this.$store.dispatch('isLoading', true)
      try {
        const response = await axios.get('/products', {
          params: { tag: slug }
        })
        console.log(response.data.data)
        this.products = response.data.data
      } catch (error) {
        console.error('篩選商品失敗 (Slug):', error)
      } finally {
        this.$store.dispatch('isLoading', false)
      }
    },

    async getProductsById (tagId) {
      this.$store.dispatch('isLoading', true)
      try {
        const response = await axios.get('/products', {
          params: { tag_id: tagId }
        })
        console.log(response.data.data)
        // this.products = response.data
      } catch (error) {
        console.error('篩選商品失敗 (ID):', error)
      } finally {
        this.$store.dispatch('isLoading', false)
      }
    }
  }
}
